export type WebsiteStudioSaveOptions = { featured?: boolean };

export type WebsiteStudioEditorPersistence<
  Data,
  Record,
  ListResult,
  LifecycleRequest,
  PreviewResult,
> = {
  load(): Promise<ListResult>;
  create(data: Data, options?: WebsiteStudioSaveOptions): Promise<Record>;
  update(id: string, data: Data, expectedVersion: number, options?: WebsiteStudioSaveOptions): Promise<Record>;
  saveChanges(id: string, data: Data, expectedVersion: number, options?: WebsiteStudioSaveOptions): Promise<Record>;
  setFeaturedOrder(order: string[]): Promise<string[]>;
  preview(id?: string): Promise<PreviewResult>;
  transition(id: string, request: LifecycleRequest): Promise<Record>;
};

export function createWebsiteStudioEditorPersistence<Data, Record, ListResult, LifecycleRequest, PreviewResult>(input: {
  load: () => Promise<ListResult>;
  save: (data: Data, id?: string, expectedVersion?: number, options?: WebsiteStudioSaveOptions) => Promise<Record>;
  saveFeaturedOrder: (order: string[]) => Promise<string[] | { featuredIds: string[] }>;
  preview: (id?: string) => Promise<PreviewResult>;
  transition: (id: string, request: LifecycleRequest) => Promise<Record>;
}): WebsiteStudioEditorPersistence<Data, Record, ListResult, LifecycleRequest, PreviewResult> {
  const update = (id: string, data: Data, expectedVersion: number, options?: WebsiteStudioSaveOptions) =>
    input.save(data, id, expectedVersion, options);
  return {
    load: input.load,
    create: (data, options) => input.save(data, undefined, 0, options),
    update,
    saveChanges: update,
    setFeaturedOrder: async (order) => {
      const saved = await input.saveFeaturedOrder(order);
      return Array.isArray(saved) ? saved : saved.featuredIds;
    },
    preview: input.preview,
    transition: input.transition,
  };
}